"use client"

import Script from "next/script"

// GTM_ID is inlined at build time via the `env` block in next.config.js.
const GTM_ID = process.env.GTM_ID

/**
 * Loads the Google Tag Manager container.
 *
 * Uses next/script's `afterInteractive` strategy — the strategy Next.js
 * documents for tag managers/analytics (and the one the official
 * @next/third-parties GoogleTagManager component uses): the container is
 * fetched as soon as the page becomes interactive, without blocking
 * first-party hydration. The inline snippet initializes `window.dataLayer`
 * before requesting gtm.js, matching GTM's official snippet.
 */
export default function GoogleTagManager() {
  if (!GTM_ID) {
    return null
  }

  return (
    <>
      <Script
        id="gtm-script"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${GTM_ID}');`,
        }}
      />
      <noscript>
        <iframe
          src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
          height="0"
          width="0"
          style={{ display: "none", visibility: "hidden" }}
          title="Google Tag Manager"
        />
      </noscript>
    </>
  )
}
